import React, { useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { searchVenueSchedule, createEventVenue } from "../../services/eventService";

const getCurrentDateTime = () => {
  const now = new Date();
  const offset = now.getTimezoneOffset();
  const local = new Date(now.getTime() - offset * 60000);
  return local.toISOString().slice(0, 16);
};

const CreateVenue = () => {

  const { eventId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const eventNature = location.state?.eventNature;
  const cityId = location.state?.cityId;

  const [venues, setVenues] = useState([
    {
      venueName: "",
      description: "",
      contactPerson: "",
      designation: "",
      contactNo: "",
      address1: "",
      address2: "",
      duration: "",
      dateTime: getCurrentDateTime()
    }
  ]);

  const [venueResults, setVenueResults] = useState([]);
  const [activeSearchIndex, setActiveSearchIndex] = useState(null);
  const [searchText, setSearchText] = useState({});

  /* ADD VENUE */
  const addVenue = () => {

    if (eventNature === "SINGLE_LOCATION") return;

    setVenues([
      ...venues,
      {
        venueName: "",
        description: "",
        contactPerson: "",
        designation: "",
        contactNo: "",
        address1: "",
        address2: "",
        duration: "",
        dateTime: getCurrentDateTime()
      }
    ]);

  };

  /* REMOVE VENUE */
  const removeVenue = (index) => {

    const updated = venues.filter((_, i) => i !== index);
    setVenues(updated);

  };

  /* HANDLE CHANGE */
  const handleChange = (index, field, value) => {

    const updated = [...venues];
    updated[index][field] = value;
    setVenues(updated);

  };

  /* SEARCH VENUE */
  const handleVenueSearch = async (index, value) => {

    setSearchText(prev => ({
      ...prev,
      [index]: value
    }));

    setActiveSearchIndex(index);

    if (value.length < 2) {
      setVenueResults([]);
      return;
    }

    try {

      const res = await searchVenueSchedule(value);

      setVenueResults(res.data || []);

    } catch (error) {
      console.error("Venue search failed", error);
    }

  };

  /* SELECT VENUE */
  const selectVenue = (index, venueData) => {

    const updated = [...venues];

    updated[index].venueName = venueData.venueName || "";
    updated[index].address1 = venueData.addressLine1 || "";
    updated[index].address2 = venueData.addressLine2 || "";
    updated[index].contactPerson = venueData.contactPerson || "";
    updated[index].contactNo = venueData.contactNo || "";

    setVenues(updated);

    setSearchText(prev => ({
      ...prev,
      [index]: `${venueData.addressLine1 || ""} ${venueData.addressLine2 || ""}`.trim()
    }));

    setVenueResults([]);
    setActiveSearchIndex(null);

  };

  /* BUILD API REQUEST */
  const buildVenueRequest = () => {

    return venues.map((venue) => {

      const startDate = new Date(venue.dateTime);

      const endDate = new Date(startDate);
      endDate.setMinutes(
        endDate.getMinutes() + Number(venue.duration || 0)
      );

      return {

        eventId: Number(eventId),
        createdBy: 1,

        eventVenue: {
          id: 0,
          venueName: venue.venueName,
          venueDescription: venue.description,
          status: "ACTIVE",
          contactName: venue.contactPerson,
          contactNumber: venue.contactNo,
          contactDesignation: venue.designation,
          eventIsPublic: true
        },

        venueAddress: {
          id: 0,
          cityId: 2,
          cityName: "",
          addressLine1: venue.address1,
          addressLine2: venue.address2,
          status: "ACTIVE",
          venueTag: "EVENT"
        },

        venueSchedules: [
          {
            id: 0,
            eventDuration: Number(venue.duration),
            eventStartDateTime: startDate.toISOString(),
            eventEndDateTime: endDate.toISOString()
          }
        ]

      };

    });

  };

  /* SUBMIT */
  const handleSubmit = async () => {

    try {

      const payload = buildVenueRequest();

      console.log("Venue Payload", payload);

      await createEventVenue(payload);

      navigate(`/event-preview/${eventId}`);

    } catch (error) {

      console.error("Venue create failed", error);

    }

  };

  return (

    <div className="px-0 py-5">

      {/* Breadcrumb */}
      <div className="text-xs mb-4 flex gap-1">
        <span className="text-gray-400">Home /</span>
        <span className="text-black font-medium">Create an Event</span>
      </div>

     {/* Step Indicator */}
     <div className="flex flex-wrap items-center justify-start gap-y-6 mb-10">

       {[1, 2, 3, 4].map((step, index) => (
         <div key={step} className="flex items-center">

           <div
             className={`w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center text-xs sm:text-sm font-semibold
             ${step === 1 ? "bg-[#65AE5C] text-white" :
             step === 2 ? "bg-[#65AE5C] text-white" :
             step === 3 ? "bg-yellow-400 text-white" : "bg-gray-300 text-white"}`}
           >
             {step}
           </div>

           {index !== 3 && (
             <div className="flex items-center mx-2 sm:mx-4">
               <div className="w-8 sm:w-16 h-[2px] bg-neutral-400"></div>
               <div className="w-0 h-0 border-t-[5px] border-b-[5px] border-l-[8px] border-t-transparent border-b-transparent border-l-neutral-400"></div>
             </div>
           )}

         </div>
       ))}

     </div>

      <h1 className="text-2xl font-semibold mb-10">Create Venue</h1>

      {venues.map((venue, index) => (

        <div key={index} className="mb-10 relative">

          {venues.length > 1 && eventNature === "MULTI_VENUE" && (
            <button
              onClick={() => removeVenue(index)}
              className="absolute right-0 top-0 text-red-500"
            >
              Delete
            </button>
          )}

          {eventNature === "MULTI_VENUE" && venues.length > 1 && (
            <div className="text-black text-sm font-medium font-['Poppins'] mb-6">
              Add Multiple Venues
            </div>
          )}

          <div className="text-black text-2xl font-medium mb-6">
            {eventNature === "MULTI_VENUE"
              ? `Venue Detail ${index + 1}`
              : "Venue Detail"}
          </div>

          {/* SEARCH VENUE */}
          <div className="relative mb-2">
            <input
              type="text"
              placeholder="Search venue"
              value={searchText[index] || ""}
              onChange={(e) => handleVenueSearch(index, e.target.value)}
              className="w-full h-12 px-5 pr-10 border border-neutral-200 outline-none"
            />

            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-5 h-5 text-gray-400 absolute right-3 top-1/2 transform -translate-y-1/2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M21 21l-4.35-4.35M16 10.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0z"
              />
            </svg>
          </div>

          {/* SEARCH RESULTS */}
          {venueResults.length > 0 && activeSearchIndex === index && (
            <div className="border border-neutral-200 max-h-40 overflow-y-auto mb-6">
              {venueResults.map((v, i) => (
                <div
                  key={i}
                  onClick={() => selectVenue(index, v)}
                  className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                >
                  {v.addressLine1 + " " + v.addressLine2}
                </div>
              ))}
            </div>
          )}

          {/* VENUE NAME */}
          <div className="grid grid-cols-2 gap-10 mb-10">
            <input
              type="text"
              placeholder="Venue name"
              value={venue.venueName}
              onChange={(e) => handleChange(index, "venueName", e.target.value)}
              className="h-12 px-5 border border-neutral-200 outline-none"
            />
          </div>

          {/* DESCRIPTION */}
          <textarea
            placeholder="Venue Description"
            value={venue.description}
            onChange={(e) => handleChange(index, "description", e.target.value)}
            className="w-full h-44 px-5 py-3 border border-neutral-200 mb-10 outline-none"
          />

          {/* CONTACT GRID */}
          <div className="grid grid-cols-2 gap-10 mb-10">

            <input
              type="text"
              placeholder="Contact Person"
              value={venue.contactPerson}
              onChange={(e) => handleChange(index, "contactPerson", e.target.value)}
              className="h-12 px-5 border border-neutral-200 outline-none"
            />

            <input
              type="text"
              placeholder="Contact No."
              value={venue.contactNo}
              onChange={(e) => handleChange(index, "contactNo", e.target.value)}
              className="h-12 px-5 border border-neutral-200 outline-none"
            />

            <input
              type="text"
              placeholder="Designation"
              value={venue.designation}
              onChange={(e) => handleChange(index, "designation", e.target.value)}
              className="h-12 px-5 border border-neutral-200 outline-none"
            />

            <input
              type="text"
              placeholder="Address Line1"
              value={venue.address1}
              onChange={(e) => handleChange(index, "address1", e.target.value)}
              className="h-12 px-5 border border-neutral-200 outline-none"
            />

            <input
              type="text"
              placeholder="Address Line 2"
              value={venue.address2}
              onChange={(e) => handleChange(index, "address2", e.target.value)}
              className="h-12 px-5 border border-neutral-200 outline-none"
            />

          </div>

          {/* DATE TIME */}
          <div className="grid grid-cols-2 gap-10">

            <input
              type="number"
              placeholder="Event Duration (In Minutes)"
              value={venue.duration}
              onChange={(e) => handleChange(index, "duration", e.target.value)}
              className="h-14 px-5 border border-neutral-200 outline-none"
            />

            <input
              type="datetime-local"
              value={venue.dateTime}
              onChange={(e) => handleChange(index, "dateTime", e.target.value)}
              className="h-14 px-5 border border-neutral-200 outline-none"
            />

          </div>

        </div>

      ))}

      {/* ADD VENUE */}
      {eventNature === "MULTI_VENUE" && (
        <div className="flex justify-end mb-12">
          <button
            onClick={addVenue}
            className="border border-black px-6 py-3"
          >
            Add Another Venue
          </button>
        </div>
      )}

      {/* SAVE */}
      <div className="flex justify-end">
        <button
          onClick={handleSubmit}
          className="w-80 h-12 bg-green-700 text-white font-bold uppercase"
        >
          Save and Continue
        </button>
      </div>

    </div>
  );
};

export default CreateVenue;